export const SET_ADDRESS_LAT_LONG = 'SET_ADDRESS_LAT_LONG'
export const SET_DELIVERY_PATIENT_ADDRESS = 'SET_DELIVERY_PATIENT_ADDRESS'